import classNames from "classnames";
import {AnyProduct} from "@/entities/product";
import {useFavorite} from "../model/useFavorite";
import {Checkbox} from "@/shared/ui/Checkbox";
import {Svg} from "@/shared/ui/Svg";
import {observer} from "mobx-react";
import {mapProductToFavorite} from "../lib/mapProductToFavorite";
import styles from "./FavoriteButton.module.scss";

type Props = {
    product: AnyProduct;
    className?: string;
};

export const FavoriteButton = observer(({product, className}: Props) => {
    const favoriteProduct = mapProductToFavorite(product);

    const {checked, favoriteChange} = useFavorite(favoriteProduct);

    const svgClasses = classNames(
        styles.svgIcon,
        {
            [styles.checked]: checked,
            [styles.notChecked]: !checked,
        }
    );

    return (
        <Checkbox
            name={`favorites`}
            className={className}
            checked={checked}
            icon={<Svg id={`favouritesIcon`} className={svgClasses} />}
            checkedIcon={<Svg id={`favouritesIcon`} className={svgClasses} />}
            onChange={favoriteChange}
        />
    );
});
